import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = { media_id: string };

type MutationResponse = {
  status: number;
  data: { url?: string; [key: string]: unknown };
};

// GET under the hood — the media_id must be pre-approved as short-lived
// (Meta media URLs expire in ~5 minutes), so this is fetched on demand
// rather than cached like a normal query.
export const useGetMediaUrlMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while fetching the download link',
    endpoint: ({ media_id }) => `/api/admin/whatsapp/media/${media_id}`,
    method: 'GET',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
